"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatorGroupsSchema = void 0;
const zod_1 = require("zod");
const calculator_group_schema_1 = require("./calculator-group.schema");
exports.calculatorGroupsSchema = zod_1.z.array(calculator_group_schema_1.calculatorGroupSchema).describe("List of calculator groups");
